import { Icon, SpinButton, TextField } from "@fluentui/react";
import React, { useEffect, useRef, useState } from "react";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { UnstyledButton } from "../../Buttons";
import "./SpintrSpinButton.scss";
import { localize } from "src/l10n";
import { uniqueId } from "src/utils";

interface IProps {
    value?: any;
    disabled: boolean;
    onChange: (value: string) => void;
}

const SpintrSpinButton = (props: IProps) => {
    const ref = useRef();
    const [key, setKey] = useState(uniqueId());

    useEffect(() => {
        if (!props.value) {
            setKey(uniqueId());
        }
    }, [props.value]);

    const formatValue = (input: string) => {
        const number = Number(input.replace(/ /g, "").replace(/,/g, "."));

        if (isNaN(number)) {
            return "";
        }

        return number.toString();
    }

    return (
        <div className="SpintrSpinButton" key={key}>
            <SpinButton
                ref={ref}
                value={props.value}
                step={1}
                disabled={props.disabled}
                onPaste={(event: React.ClipboardEvent<HTMLDivElement>) => {
                    event.preventDefault();
                    const input = event.clipboardData.getData("Text");

                    if (!input) {
                        return;
                    }

                    props.onChange(formatValue(input));
                }}
                className="spinButton"
                onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, newValue?: string) => {
                    props.onChange(formatValue(newValue));
                }}
                onValidate={(value: string) => {
                    return formatValue(value);
                }}
            />
            {props.value !== undefined && props.value !== "" && (
                 <UnstyledButton
                    className="clear-button"
                    title={localize("Rensa")}
                    onClick={() => {
                        props.onChange("");
                    }}>
                    <Icon iconName="Cancel" />
                </UnstyledButton>
            )}
        </div>
    )
}

export default SpintrSpinButton;